import React, { useEffect, useState } from 'react';
import { Provider } from "react-redux";
import Home from "./components/Home";
import Gallery from "./components/Gallery";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Exhibitions from "./components/Exhibitions";
import Archive from "./components/Archive"
import AboutMe from "./components/AboutMe"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import useStyles from './styles';
import { createStore, compose, applyMiddleware } from 'redux';
import reducers from './reducers'
import thunk from 'redux-thunk'
import Auth from './components/Auth/Auth';
import { createTheme } from '@material-ui/core';
import { purple, lightBlue } from '@mui/material/colors';
import { ThemeProvider } from '@mui/material/styles';


const theme = createTheme({
    palette: {
        primary: {
            main: '#616161'
        },
        secondary: {
            main: '#fb8c00'
        }
    }
    

});

const store = createStore(reducers, compose(applyMiddleware(thunk)));

const App = () => {

    const classes = useStyles();



    return (
        <ThemeProvider theme={theme}>
            <Provider store={store}>
                <Router >

                    <div className={classes.app}>

                        <Navbar />
                        <Home />
                        {/* <Gallery /> */}
                        <AboutMe />
                        <Exhibitions/>
                        {/* <Switch>
                            <Route path="/" exact component={Home} />
                            <Route path="/home" exact component={Home} /> 
                            <Route path="/auth" component={Auth} />
                            <Route path="/gallery" component={Gallery} />
                            <Route path="/about" component={AboutMe} />
                            <Route path="/exhibitions" component={Exhibitions} />
                            <Route path="/archive" component={Archive} />
                        </Switch> */}

                        <Footer />

                    </div>

                </Router>
            </Provider>
        </ThemeProvider>

    );
}
export default App;